import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Subtitle } from "capitalrx-components-2.0/lib/typography";

import { ExperienceContext } from "@/App/context";
import { MemberEligibilityContext } from "@/App/context/MemberEligibilityContext";
import { getCustomerSupportNumber } from "@/App/utils/utils";

const TRANSLATION_PATH = "DASHBOARD.recentActivityDashboard.needHelp";

const NeedHelpPanel = styled.div`
  border-radius: 8px;
  border: 1px solid #cfd9e1;
  padding: 24px;
  width: 100%;
`;

const PhoneLink = styled.a`
  color: #0071bc;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const NeedHelpTile: FC = () => {
  const { t: translate } = useTranslation();
  const { hideCustomerCarePhoneNumber, customerSupportPhoneNumber, customerSupportHours } = useContext(ExperienceContext);
  const { memberEligibility } = useContext(MemberEligibilityContext);

  const customerSupportNumber = getCustomerSupportNumber(memberEligibility, customerSupportPhoneNumber);
  const hours = customerSupportHours || translate(`${TRANSLATION_PATH}.defaultHours`);

  if (hideCustomerCarePhoneNumber) {
    return null;
  }

  return (
    <NeedHelpPanel data-testid="need-help-tile">
      <Stack spacing="small" alignment="left">
        <Shelf alignment="center" spacing="small">
          <Icon name="phone" size="small" />
          <Subtitle>{translate(`${TRANSLATION_PATH}.title`)}</Subtitle>
        </Shelf>
        <Body>
          {translate(`${TRANSLATION_PATH}.contactPrefix`)}{" "}
          <PhoneLink href={`tel:${customerSupportNumber}`}>{customerSupportNumber}</PhoneLink>.{" "}
          {translate(`${TRANSLATION_PATH}.contactSuffix`, { hours })}
        </Body>
      </Stack>
    </NeedHelpPanel>
  );
};
